import { CARE_MEDICATION_ASK_QUESTION_PATTERN } from '../../shared/careMedicationPatterns';

export const ASK_COLORS = {
  accent: '#7C6AAE',
  accentDark: '#5B4B8A',
  accentSoft: '#EFE8F8',
  accentPale: '#F8F5FC',
  sage: '#6FAA98',
  sageSoft: '#E5F1EC',
  sagePale: '#F3FAF7',
  inkMuted: '#7D8B86',
  border: '#DDE8E3',
  surface: '#FBFCFA',
  sourceSurface: '#F8FBF8',
};

export const ASK_ACCENT = ASK_COLORS.accent;
export const ASK_ACCENT_DARK = ASK_COLORS.accentDark;
export const ASK_TINT = ASK_COLORS.accentPale;
export const ASK_SAGE_TINT = ASK_COLORS.sagePale;

export const getFirstName = (name = '') => String(name || '').trim().split(/\s+/)[0] || 'this child';

export const formatConfidenceLabel = (confidence = 'low') => `${String(confidence || 'low').toUpperCase()} CONFIDENCE`;

export const formatLogCount = (logCount) => {
  const count = Number(logCount);
  if (!Number.isFinite(count) || count < 1) {
    return 'Saved logs';
  }
  return `${count.toLocaleString()} saved log${count === 1 ? '' : 's'}`;
};

const escapeRegExp = (value = '') => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getResultTitle = (question = '', firstName = 'this child') => {
  const normalizedQuestion = String(question || '').trim();
  const lowerQuestion = normalizedQuestion.toLowerCase();
  if (lowerQuestion.includes('sleep')) {
    return 'Sleep this week';
  }
  if (CARE_MEDICATION_ASK_QUESTION_PATTERN.test(lowerQuestion)) {
    return 'Medication notes';
  }
  if (/\bbehavior|aggression|meltdown|incident|transition\b/.test(lowerQuestion)) {
    return 'Behavior patterns';
  }
  if (/\bfood|appetite|breakfast|lunch|dinner|snack|eat|ate\b/.test(lowerQuestion)) {
    return 'Food and appetite';
  }
  if (/\bschool|therapy|aba|ot\b/.test(lowerQuestion)) {
    return 'School and therapy';
  }

  const cleanedQuestion = normalizedQuestion
    .replace(/\?+$/, '')
    .replace(new RegExp(`\\b${escapeRegExp(firstName)}\\b`, 'ig'), '')
    .replace(/\s+/g, ' ')
    .trim();
  return cleanedQuestion ? `${cleanedQuestion.slice(0, 34)}${cleanedQuestion.length > 34 ? '...' : ''}` : 'Record answer';
};
